import React from 'react';
import HomeScreen from "../../homescreen/homescreen";
import LoadingComponent from "../../../components/Loading";
import ErrorMessage from "../../../components/ErrorMessage";
import Service from "../../../service/service";
import SuccessMessage from "../../../components/SuccessMessage";

class Register extends HomeScreen {

    registerInfo = {
        username: '',
        password: '',
        secondPassword: '',
        email: '',
        firstName: '',
        lastName: '',
    }

    state = {
        registerInfo: this.registerInfo,
        loading: false,
        errorMessage: null,
        success: false
    }

    service = new Service();

    getScreenName() {
        return 'Register';
    }

    handleChange = (event) => {
        this.registerInfo[event.target.name] = event.target.value;
        this.setState(this.registerInfo);
    };

    register = () => {
        if (this.validateForm()) {
            this.state.errorMessage = null;
            this.state.loading = true;
            this.setState(this.state);

            this.service.register(this.registerInfo)
                .then(response => {
                    // TODO: should show the success page.
                    console.debug(response);
                    this.state.loading = false;
                    this.state.success = true;
                    this.setState(this.state);
                })
                .catch(error => {
                    console.log(error);
                    this.state.loading = false;
                    //TODO: will need to check the error messages.. ie. if the username was already taken.
                    this.state.errorMessage = 'There was an error. Please, try again later';
                    this.setState(this.state);
                });
        } else {
            this.state.errorMessage = 'Please fill all the required fields from the form, and try again';
            this.setState(this.state);
        }
    };

    validateForm = () => {
        const {username, password, secondPassword, email, firstName, lastName} = this.registerInfo;

        if (password.length <= 4 && password !== secondPassword) {
            console.log('incorrect password');
            return false;
        }

        if (username.length <= 4) {
            console.log('invalid username');
            return false;
        }

        if (firstName <= 3 && lastName <= 2) {
            console.log('invalid first name and last name');
            return false;
        }

        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
            console.log('invalid email..');
            return false;
        }

        return true;
    };

    renderHomeContent() {
        const {errorMessage, loading, success} = this.state;
        const buttonClass = loading ? 'myButton myButtonDisabled' : 'myButton myButtonActive';

        if (success) {
            return this.renderRegisterSuccess();
        }

        return (
            <div>
                <p className='sectionDescription'>Please, fill the following form to create an account. If you already created an account, <a href='/login'>login</a> instead.</p>
                <div className='formContainer'>
                    <div>
                        <label>Username:</label>
                        <input type='text'
                               name='username'
                               placeholder='Username'
                               value={this.registerInfo.username}
                               onChange={this.handleChange} disabled={loading} />
                    </div>

                    <div>
                        <label>Password:</label>
                        <input type='password'
                               name='password'
                               placeholder='Password'
                               value={this.registerInfo.password}
                               onChange={this.handleChange} disabled={loading} />
                    </div>

                    <div>
                        <label>Repeat the Password:</label>
                        <input type='password'
                               name='secondPassword'
                               placeholder='Password'
                               value={this.registerInfo.secondPassword}
                               onChange={this.handleChange} disabled={loading} />
                    </div>

                    <div>
                        <label>Email:</label>
                        <input type='text'
                               name='email'
                               placeholder='Email'
                               value={this.registerInfo.email}
                               onChange={this.handleChange} disabled={loading} />
                    </div>

                    <div>
                        <label>First Name:</label>
                        <input type='text'
                               name='firstName'
                               placeholder='First Name'
                               value={this.registerInfo.firstName}
                               onChange={this.handleChange} disabled={loading} />
                    </div>

                    <div>
                        <label>Last Name:</label>
                        <input type='text'
                               name='lastName'
                               placeholder='Last Name'
                               value={this.registerInfo.lastName}
                               onChange={this.handleChange} disabled={loading} />
                    </div>

                    <LoadingComponent isLoading={loading} />

                    <ErrorMessage errorMessage={errorMessage} type='warning'/>

                </div>

                <div className='buttonContainer'>
                    <div className={buttonClass} onClick={this.register}>Register</div>
                </div>
            </div>
        );
    }

    renderRegisterSuccess = () => {
        return (
            <SuccessMessage renderFunc={this.registrationSuccessMsg}/>
        );
    };

    registrationSuccessMsg = () => {
        return (
            <div>
                <p>You have been registered successfully. You'll be redirected soon.</p>
                <p>If you haven't, please visit the <b className='sectionDescription'><a href='/login'>following link</a></b></p>
            </div>
        );
    };
}

export default Register;


// WEBPACK FOOTER //
// ./src/screens/access/registry/index.js